module.exports = __webpack_public_path__ + "static/SaolText-Book-781d3ad9fe05265bc7f83517f2d89ded.woff2";